import React, { useState } from 'react';
import Logo from '../../Assets/Logo.svg';
import bg from '../../Assets/hamburger_bg.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import close from '../../Assets/close.svg';
import servicesData from '../../ourServices.json';
import BookingModal from '../Common/BookingModal';

const BottomNavbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isClickedService, setIsClickedService] = useState(false);
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const slideInAnimation = useSpring({
        transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
    });

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="">
            {/* //Desktop */}
            <div className='lg:contents hidden  '>
                <div className='flex items-center justify-between px-10 py-2 shadow-md'>
                    <div>
                        <img src={Logo} alt="Logo_img" className='w-[250px]' />
                    </div>
                    <div className='flex gap-10 items-center font-sans font-medium'>
                        <Link to='/'>
                            Home
                        </Link>

                        <Link to='/about'>
                            About
                        </Link>

                        <div>
                            <div className="relative group">
                                <button className="px-3 py-2">
                                    Services
                                </button>
                                <div className="cursor-pointer absolute left-0 bg-white text-primaryTextColor opacity-0 visibility-hidden pointer-events-none transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:visibility-visible group-hover:pointer-events-auto shadow-lg z-50">
                                    <ul className="rounded-lg">
                                        {servicesData.services.map((service, i) => (
                                            <li
                                                key={i}
                                                onClick={() => navigate(`/service-details/${service.serviceId}`)}
                                                className="px-4 py-2 hover:bg-primaryOrangeColor hover:text-white tracking-wide text-sm border-b-2 border-primaryBlueColor"
                                            >
                                                {service.serviceName}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>


                            {/* <li className="hov cursor-pointer">
                                Services
                                <ul className="main">
                                    {
                                        servicesData?.services?.map((data, i) => {
                                            return (
                                                <li
                                                    key={i}
                                                    onClick={() => navigate(data?.nav_link)}
                                                    className='text-sm hover:text-primaryOrangeHoverColor cursor-pointer'
                                                >
                                                    {data?.serviceName}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </li> */}
                        </div>

                        <Link to='/blogs-list'>
                            Blogs
                        </Link>

                        <Link to='/contact'>
                            Contact
                        </Link>

                        <button onClick={handleOpen} className="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-primaryBlueColor rounded hover:bg-white group">
                            <span className="w-48 h-48 rounded rotate-[-40deg] bg-gradient-to-r from-primaryOrangeColor to-primaryOrangeHoverColor absolute bottom-0 left-0 -translate-x-full ease-out duration-500 transition-all translate-y-full mb-9 ml-9 group-hover:ml-0 group-hover:mb-32 group-hover:translate-x-0"></span>
                            <span className="relative w-full text-left text-white transition-colors duration-300 ease-in-out group-hover:text-white">Request a quote</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* //Mobile */}
            <div className='lg:hidden contents'>
                <div className='px-10 py-3 flex items-center justify-between overflow-hidden' style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'right' }}>
                    {/* Your logo code here */}
                    <svg width="176" height="50" viewBox="0 0 156 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M55.2389 25.8529H60.3743L57.8185 18.0661L55.2389 25.8529ZM61.7836 30.2001L60.8281 27.2621H54.7851L53.8057 30.2001H49.363L55 15.3432H60.6609L66.3219 30.2001H61.7836ZM70.9863 15.3432H75.7634V30.2001H70.9863V15.3432ZM86.5187 16.7524V23.4643H90.4599C90.7624 23.4643 90.9615 23.4165 91.057 23.321C91.1525 23.2254 91.2003 23.0264 91.2003 22.7238V17.4929C91.2003 17.1744 91.1525 16.9753 91.057 16.8957C90.9615 16.8002 90.7624 16.7524 90.4599 16.7524H86.5187ZM86.5187 24.8736V30.2001H81.9088V15.3432H93.9233C95.1813 15.3432 95.8103 15.9721 95.8103 17.2301V22.9866C95.8103 24.2446 95.1813 24.8736 93.9233 24.8736H92.8484L96.2163 30.2001H91.4153L88.2385 24.8736H86.5187ZM114.867 20.2158H110.257V17.4929C110.257 17.1744 110.209 16.9753 110.114 16.8957C110.018 16.8002 109.819 16.7524 109.516 16.7524H106.578C106.26 16.7524 106.053 16.8002 105.957 16.8957C105.878 16.9753 105.838 17.1744 105.838 17.4929V28.0504C105.838 28.3688 105.878 28.5758 105.957 28.6714C106.053 28.751 106.26 28.7908 106.578 28.7908H109.516C109.819 28.7908 110.018 28.751 110.114 28.6714C110.209 28.5758 110.257 28.3688 110.257 28.0504V23.9659H107.82V22.5566H114.867V28.3131C114.867 29.5711 114.238 30.2001 112.98 30.2001H103.115C101.857 30.2001 101.228 29.5711 101.228 28.3131V17.2301C101.228 15.9721 101.857 15.3432 103.115 15.3432H112.98C114.238 15.3432 114.867 15.9721 114.867 17.2301V20.2158ZM134.004 17.2301V28.3131C134.004 29.5711 133.375 30.2001 132.117 30.2001H122.228C120.97 30.2001 120.341 29.5711 120.341 28.3131V17.2301C120.341 15.9721 120.97 15.3432 122.228 15.3432H132.117C133.375 15.3432 134.004 15.9721 134.004 17.2301ZM129.418 28.0504V17.4929C129.418 17.1744 129.37 16.9753 129.275 16.8957C129.179 16.8002 128.98 16.7524 128.677 16.7524H125.692C125.373 16.7524 125.166 16.8002 125.071 16.8957C124.991 16.9753 124.951 17.1744 124.951 17.4929V28.0504C124.951 28.3688 124.991 28.5758 125.071 28.6714C125.166 28.751 125.373 28.7908 125.692 28.7908H128.677C128.98 28.7908 129.179 28.751 129.275 28.6714C129.37 28.5758 129.418 28.3688 129.418 28.0504ZM149.745 15.3432H154.02V30.2001H150.055L144.06 19.6426V30.2001H139.808V15.3432H143.821L149.745 25.9245V15.3432Z" fill="#FFAE02" />
                        <path d="M38.1543 14.2517L22.0629 23.5352C22.0239 23.5576 22 23.5991 22 23.6441V42.2109C22 42.3077 22.1047 42.3682 22.1885 42.3198L38.2799 33.0363C38.3189 33.0139 38.3428 32.9723 38.3428 32.9274V14.3605C38.3428 14.2638 38.2381 14.2033 38.1543 14.2517Z" fill="#EC9230" />
                        <path d="M10.1188 16.6207L26.9632 6.63874C27.0034 6.61494 27.0535 6.61536 27.0932 6.63983L30.9354 9.00423C31.0163 9.05404 31.0149 9.17217 30.9327 9.21996L13.8911 19.1351C13.8524 19.1576 13.8286 19.199 13.8286 19.2438V38.7366C13.8286 38.837 13.7167 38.8969 13.6331 38.8412L10.1131 36.4945C10.0781 36.4712 10.0571 36.4319 10.0571 36.3899V16.7288C10.0571 16.6844 10.0806 16.6433 10.1188 16.6207Z" fill="#EC9230" />
                        <path d="M3.77142 32.6155V14.6676C3.77142 14.5725 3.87298 14.5118 3.95674 14.5569L7.79102 16.6216C7.83174 16.6435 7.85714 16.686 7.85714 16.7322V34.975C7.85714 35.0734 7.7493 35.1336 7.66554 35.0821L3.83125 32.7225C3.79407 32.6997 3.77142 32.6591 3.77142 32.6155Z" fill="#273679" />
                        <path d="M15.7143 39.5298V21.5819C15.7143 21.4868 15.8159 21.4261 15.8996 21.4712L19.7339 23.5359C19.7746 23.5578 19.8 23.6003 19.8 23.6465V41.8893C19.8 41.9877 19.6922 42.048 19.6084 41.9964L15.7741 39.6369C15.7369 39.614 15.7143 39.5734 15.7143 39.5298Z" fill="#273679" />
                        <path d="M8.73641 14.7344L5.21397 12.6796C5.13099 12.6312 5.13077 12.5114 5.21357 12.4627L20.8843 3.24461C20.9642 3.19758 20.9675 3.08311 20.8903 3.03166L20.3837 2.69396C20.2883 2.63032 20.321 2.48255 20.4344 2.46511L28.0375 1.29539C28.1399 1.27965 28.2163 1.38744 28.1676 1.4788L25.8367 5.84912C25.8018 5.91467 25.7179 5.93577 25.6561 5.89456L24.8942 5.38662C24.8541 5.35989 24.8022 5.35843 24.7607 5.38287L8.8635 14.7342C8.8243 14.7572 8.7757 14.7573 8.73641 14.7344Z" fill="#273679" />
                        <path d="M20.6792 21.6486L17.1568 19.5938C17.0738 19.5454 17.0736 19.4256 17.1564 19.3769L32.8271 10.1588C32.9071 10.1118 32.9103 9.9973 32.8331 9.94584L32.3265 9.60815C32.2311 9.5445 32.2638 9.39674 32.3772 9.37929L39.9803 8.20958C40.0827 8.19383 40.1591 8.30163 40.1104 8.39299L37.7795 12.7633C37.7446 12.8289 37.6607 12.85 37.5989 12.8087L36.837 12.3008C36.7969 12.2741 36.745 12.2726 36.7035 12.2971L20.8063 21.6483C20.7671 21.6714 20.7185 21.6715 20.6792 21.6486Z" fill="#273679" />
                    </svg>

                    {/* Icon */}
                    <div onClick={toggleMenu}>
                        {
                            isOpen ?
                                <img src={close} alt="" />
                                :
                                <svg width="35" height="28" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="25" height="2.8" rx="1.4" fill="black" />
                                    <rect y="15" width="25" height="2.8" rx="1.4" fill="black" />
                                    <rect y="7" width="20" height="2.8" rx="1.4" fill="black" />
                                    <rect x="22" y="7" width="3" height="3" rx="1.5" fill="#D9D9D9" />
                                </svg>}
                    </div>
                </div>

                {/* Hamburger menu */}
                <animated.div className='bg-white  md:w-[50%] w-[75%] h-[100vh] overflow-y-scroll  fixed top-0 left-0 right-0 z-50 shadow-xl font-sans ' style={slideInAnimation}>
                    <div className="p-6 flex flex-col gap-2">
                        <Link className='py-2 border px-6' to='/'>
                            Home
                        </Link>
                        <Link className='py-2 border px-6' to='/about'>
                            About
                        </Link>
                        <div className='py-2 border px-6 cursor-pointer' onClick={() => setIsClickedService(!isClickedService)}>
                            Services
                        </div>
                        {isClickedService && (
                            <div className='flex flex-col gap-2 ml-6'>
                                {servicesData?.services?.map((data, i) => (
                                    <Link key={i} className='py-2 border px-6' to={`/service-details/${data.serviceId}`}>
                                        {data?.serviceName}
                                    </Link>
                                ))}
                            </div>
                        )}
                        <Link className='py-2 border px-6' to='/blogs-list'>
                            Blog
                        </Link>
                        <Link className='py-2 border px-6' to='/contact'>
                            Contact
                        </Link>
                    </div>
                </animated.div>
            </div>
            <BookingModal open={open} handleClose={handleClose} />
        </div>
    );
};

export default BottomNavbar;
